var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreativity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_659_3237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F26B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0754 30.2157C5.9779 25.5332 8.21706 16.9598 10.9246 12.784C17.2304 3.05568 26.4421 1.59318 28.0796 5.59484C29.4646 8.97984 22.6554 12.389 24.2329 14.1382C25.6179 15.674 29.9729 10.2798 32.3812 13.4023C33.5404 14.9048 35.6196 20.1723 27.8487 28.2157C23.6521 32.5582 15.1746 36.0432 10.0754 30.2157Z",
    fill: "#F7E4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1836 16.8633C23.6002 18.4549 23.4061 20.6708 24.2052 21.2474C25.2502 22.0016 27.5819 21.0416 28.5569 18.5149C29.8569 15.1441 26.5527 15.4866 25.1836 16.8633Z",
    fill: "#F26B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5286 13.4201C20.6792 13.4201 21.612 12.4873 21.612 11.3368C21.612 10.1862 20.6792 9.25342 19.5286 9.25342C18.3781 9.25342 17.4453 10.1862 17.4453 11.3368C17.4453 12.4873 18.3781 13.4201 19.5286 13.4201Z",
    fill: "#FF6419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.18 17.6393C16.3306 17.6393 17.2633 16.7066 17.2633 15.556C17.2633 14.4054 16.3306 13.4727 15.18 13.4727C14.0294 13.4727 13.0967 14.4054 13.0967 15.556C13.0967 16.7066 14.0294 17.6393 15.18 17.6393Z",
    fill: "#EFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.097 24.3424C14.2476 24.3424 15.1803 23.4097 15.1803 22.2591C15.1803 21.1085 14.2476 20.1758 13.097 20.1758C11.9464 20.1758 11.0137 21.1085 11.0137 22.2591C11.0137 23.4097 11.9464 24.3424 13.097 24.3424Z",
    fill: "#A5B226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.18 31.2502C16.3306 31.2502 17.2633 30.3174 17.2633 29.1668C17.2633 28.0162 16.3306 27.0835 15.18 27.0835C14.0294 27.0835 13.0967 28.0162 13.0967 29.1668C13.0967 30.3174 14.0294 31.2502 15.18 31.2502Z",
    fill: "#00A2D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_659_3237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativity);
export default __webpack_public_path__ + "static/media/creativity.8b839058ac5ad52c113f091e1b1d5ad3.svg";
export { ForwardRef as ReactComponent };